import React, { useState } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { Paper } from "@mui/material";
import axios from "axios";
import {
  MapContainer,
  TileLayer,
} from "react-leaflet";
// import userIcon from "leaflet/dist/images/user.png";
// import riderIcon from "leaflet/dist/images/rider.png";
const ride_details_url ="https://api.holoapp.tech/rides/brta/get-brta-ride-alert-list";

const access = localStorage.getItem("accessToken");

export const AlertTable = ({ riders }) => {
  const [ride_id, setRideId] = useState("");

  const handleCellClick = (id) => {
    console.log("after id on click", id);

    console.log("calling");
    axios
      .get(ride_details_url, {
        params: { serial: id },
        headers: {
          Authorization: "Bearer " + access,
        },
      })
      .then((response) => {
        console.log("fggfg", response.status, response.data);
        if (response.status === 200) {
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div
      style={{
        height: 800,
        width: "100%",
        display: "flex",
        flexDirection: "row",
      }}
    >
      <CssBaseline />
      <div
        style={{
          margin: "20px",
          padding: "20px",
        }}
      >
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 500 }} aria-label="simple table">
            <TableHead>
              <TableRow>
              <TableCell align="center">Ride ID</TableCell>
              <TableCell align="center">Alert</TableCell>
              <TableCell align="center">Caller</TableCell>
              <TableCell align="center">Called Against</TableCell>
              <TableCell align="center">Location</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {riders.map((row) => {
                let location;
                location = "https://maps.google.com/?q="+row.latitude+","+row.longitude;
                let alert;
                alert = row.alert;
                return (
                    <TableRow
                      key={row.id}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell align="center">{row.ride_id}</TableCell>
                      <TableCell align="center">{alert}</TableCell>
                      <TableCell align="center">{row.account.name} / {row.account.phone}</TableCell>
                      <TableCell align="center">{row.against.name} / {row.against.phone}</TableCell>
                      <TableCell align="center"><a href={location}>{row.latitude},{row.longitude}</a></TableCell>
                    </TableRow>
                  
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div
        style={{
          margin: "20px",
          padding: "20px",
        }}
      >
      </div>
    </div>
  );
};